import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
export const getIsChildClub = (subscription) => {
    const content = getComponentContentById(subscription.product.components, CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.IS_CHILD_CLUB);
    return content?.value === true;
};
